import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Table, Badge, Form, Toast, ToastContainer, Spinner, InputGroup, Modal } from 'react-bootstrap';
import { BsTrash, BsPersonBadge, BsCashStack, BsArrowRight, BsPersonPlusFill, BsSearch, BsLockFill, BsPencilSquare, BsArrowLeftRight, BsFiles } from 'react-icons/bs';
import NominaServices from '../../../Services/Catalogos/Nomina';
import usuariosServices from '../../../Services/Catalogos/Usuarios.Services';
import DTOPeriodoCerrado from '../../../DTO/DTOPeriodoCerrado';
import { IRegister } from '../../../interfaces/IRegister';

import { triggerNominaRefresh } from '../../../Store/hooks/useNominaRefresh';

import { useMemo } from 'react'; // ← Asegúrate de tener useMemo
import DataTable, { TableColumn } from 'react-data-table-component'; // ← Import correcto


const GestionMatrizNomina: React.FC = () => {
    // --- ESTADOS ---
    const [supervisores, setSupervisores] = useState<any[]>([]);
    const [usuariosAsignados, setUsuariosAsignados] = useState<any[]>([]);
    const [comboUsuarios, setComboUsuarios] = useState<IRegister[]>([]);
    const [selectedSup, setSelectedSup] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [loadingDetalle, setLoadingDetalle] = useState(false);

    // Estados Asignación Individual
    const [idEmpleadoAAsignar, setIdEmpleadoAAsignar] = useState<number>(0);
    const [filtroBusqueda, setFiltroBusqueda] = useState("");
    const [esSoloLectura, setEsSoloLectura] = useState(false);

    // Estados Operación Masiva (Copiar/Mover)
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [tipoOperacion, setTipoOperacion] = useState(1); // 1: Copiar, 2: Transferir
    const [idDestinoMasivo, setIdDestinoMasivo] = useState(0);
    const [permisoMasivo, setPermisoMasivo] = useState(false);

    const [showToast, setShowToast] = useState(false);
    const [msgInformativo, setMsgInformativo] = useState("");
    const [showPeriodosModal, setShowPeriodosModal] = useState(false);
    const [periodosCerrados, setPeriodosCerrados] = useState<DTOPeriodoCerrado[]>([]);
    const [loadingPeriodos, setLoadingPeriodos] = useState(false);


    const [showConfirmReabrir, setShowConfirmReabrir] = useState(false);
    const [periodoSeleccionado, setPeriodoSeleccionado] = useState<DTOPeriodoCerrado | null>(null);
    const [motivoReapertura, setMotivoReapertura] = useState('');

    // Agrega este estado al componente
    const [editingPermisoId, setEditingPermisoId] = useState<number | null>(null); // ID del empleado que se está editando
    const [tempSoloLectura, setTempSoloLectura] = useState<boolean>(false); // Valor temporal del switch

    // Filtro para la tabla de periodos cerrados
const [filtroPeriodos, setFiltroPeriodos] = useState<string>('');
    



    // Función trigger (la misma en ambos)
    const triggerNominaRefresh = () => {
        localStorage.setItem('nomina_refresh_trigger', Date.now().toString());
        console.log("Refresh disparado via localStorage");
    };

    const cargarPeriodosCerrados = async () => {
        setLoadingPeriodos(true);
        try {
            const res = await NominaServices.listarPeriodosCerradoss();
            setPeriodosCerrados(res.data || []);
        } catch (err) {
            mostrarMensaje("Error al cargar periodos cerrados");
        } finally {
            setLoadingPeriodos(false);
        }
    };


    // --- CARGA INICIAL ---
    useEffect(() => {
        cargarEstructura();

        usuariosServices.getAllUsuarios()
            .then((res) => setComboUsuarios(res.data || []))
            .catch((e) => console.error(e));
    }, []);

    const cargarEstructura = async () => {
        setLoading(true);
        try {
            const res = await NominaServices.ConsultarEstructuraNomina();
            setSupervisores(res.data || []);
        } catch (error) { console.error(error); }
        finally { setLoading(false); }
    };

    const verDetalleSupervisor = async (sup: any) => {
        const idSup = sup.idSupervisor || sup.IdSupervisor;
        setLoadingDetalle(true);
        setSelectedSup(sup);
        try {
            const res = await NominaServices.ObtenerUsuariosParaNomina(idSup);
            setUsuariosAsignados(res.data || []);
        } catch (error) { mostrarMensaje("Error al obtener asignados."); }
        finally { setLoadingDetalle(false); }
    };

    // --- ACCIONES INDIVIDUALES ---
    const asignarNuevoEmpleado = async () => {
        if (idEmpleadoAAsignar === 0) return mostrarMensaje("Seleccione un usuario.");
        const idSup = selectedSup.idSupervisor || selectedSup.IdSupervisor;
        try {
            await NominaServices.GestionarEmpleadoNomina(1, idSup, idEmpleadoAAsignar, esSoloLectura);
            mostrarMensaje("Empleado vinculado.");
            setIdEmpleadoAAsignar(0);
            setEsSoloLectura(false);
            setFiltroBusqueda("");
            await verDetalleSupervisor(selectedSup);
            await cargarEstructura(); // Actualiza contadores de la izquierda
            triggerNominaRefresh();

        } catch (error) { mostrarMensaje("Error en la asignación."); }
    };

    const quitarDeNomina = async (idUsuarioEmpleado: number) => {
        if (!window.confirm("¿Quitar acceso a este empleado?")) return;
        const idSup = selectedSup.idSupervisor || selectedSup.IdSupervisor;
        try {
            await NominaServices.GestionarEmpleadoNomina(0, idSup, idUsuarioEmpleado, false);
            mostrarMensaje("Acceso eliminado.");
            await verDetalleSupervisor(selectedSup);
            await cargarEstructura(); // Actualiza contadores de la izquierda
            triggerNominaRefresh();
        } catch (error) { mostrarMensaje("Error al eliminar."); }
    };

    const actualizarPermiso = async (idUsuarioEmpleado: number, nuevoSoloLectura: boolean) => {
        const idSup = selectedSup.idSupervisor || selectedSup.IdSupervisor;
        try {
            await NominaServices.GestionarEmpleadoNomina(
                1,           // Accion = 1 (asignar/actualizar)
                idSup,
                idUsuarioEmpleado,
                nuevoSoloLectura
            );
            mostrarMensaje(`Permiso actualizado a ${nuevoSoloLectura ? "Solo Lectura" : "Escritura"}`);
            setEditingPermisoId(null); // Salir del modo edición
            await verDetalleSupervisor(selectedSup); // Refrescar lista
            triggerNominaRefresh(); // Notificar al reporte
        } catch (error) {
            mostrarMensaje("Error al actualizar permiso");
        }
    };

    // --- ACCIÓN MASIVA (COPIAR / TRANSFERIR) ---
    const ejecutarOperacionMasiva = async () => {
        if (idDestinoMasivo === 0) return alert("Seleccione un nominista destino.");
        const idOrigen = selectedSup.idSupervisor || selectedSup.IdSupervisor;

        try {
            await NominaServices.GestionMasivaNomina(tipoOperacion, idOrigen, idDestinoMasivo, permisoMasivo);
            mostrarMensaje(tipoOperacion === 1 ? "Personal copiado exitosamente." : "Personal transferido exitosamente.");
            setShowTransferModal(false);
            setIdDestinoMasivo(0);

            // Si fue transferencia (2), limpiamos selección porque el origen quedó vacío
            if (tipoOperacion === 2) setSelectedSup(null);
            else await verDetalleSupervisor(selectedSup);

            await cargarEstructura(); // Refresca contadores
            triggerNominaRefresh();
        } catch (error) { mostrarMensaje("Error en la operación masiva."); }
    };

    const mostrarMensaje = (msg: string) => {
        setMsgInformativo(msg);
        setShowToast(true);
    };

    const usuariosFiltrados = comboUsuarios.filter(u => {
        const query = filtroBusqueda.toLowerCase();
        return u.id.toString().includes(query) || (u.nombre || "").toLowerCase().includes(query);
    })

    return (
        <Container fluid className="p-4 bg-light min-vh-100">
            <Row className="g-4">

                {/* LISTA IZQUIERDA: SUPERVISORES */}
                <Col md={4}>

                    {/* <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => {
                            setShowPeriodosModal(true);
                            cargarPeriodosCerrados();
                        }}
                    >
                        Ver periodos cerrados
                    </Button> */}






                    <Card className="border-0 shadow-sm overflow-hidden h-100">

                        <Card.Header className="bg-dark text-white py-3">
                            <h6 className="mb-0 fw-bold text-uppercase small">Noministas Responsables</h6>
                        </Card.Header>
                        <Card.Body className="p-0" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                            <div className="list-group list-group-flush">
                                {supervisores.map((sup) => {
                                    const id = sup.idSupervisor || sup.IdSupervisor;
                                    const selectedId = selectedSup?.idSupervisor || selectedSup?.IdSupervisor;
                                    const total = sup.totalEmpleadosAsignados || sup.TotalEmpleadosAsignados || 0;
                                    return (
                                        <button key={id} onClick={() => verDetalleSupervisor(sup)}
                                            className={`list-group-item list-group-item-action p-3 border-start border-4 ${selectedId === id ? 'bg-primary bg-opacity-10 border-primary fw-bold' : 'border-transparent'}`}>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className={selectedId === id ? "text-primary" : ""}>{sup.nombreSupervisor || sup.NombreSupervisor}</div>
                                                    <small className="text-muted">{sup.Departamento || sup.departamento}</small>
                                                </div>
                                                <Badge bg={selectedId === id ? "primary" : "secondary"} pill>{total}</Badge>
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                {/* PANEL DERECHO: GESTIÓN DE EMPLEADOS */}
                <Col md={8}>
                    {selectedSup ? (
                        <Card className="border-0 shadow-sm">
                            <Card.Header className="bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                                <h5 className="mb-0 fw-bold text-dark">Personal de: <span className="text-primary">{selectedSup.nombreSupervisor || selectedSup.NombreSupervisor}</span></h5>
                                <div className="d-flex gap-2">
                                    <Button variant="outline-primary" size="sm" onClick={() => { setTipoOperacion(1); setShowTransferModal(true); }}>
                                        <BsFiles className="me-1" /> Copiar a...
                                    </Button>
                                    <Button variant="outline-danger" size="sm" onClick={() => { setTipoOperacion(2); setShowTransferModal(true); }}>
                                        <BsArrowLeftRight className="me-1" /> Mover a...
                                    </Button>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                {/* BUSCADOR INDIVIDUAL */}
                                <div className="p-3 bg-light rounded border mb-4 shadow-sm">
                                    <h6 className="small fw-bold text-muted mb-3"><BsPersonPlusFill className="me-2" />VINCULAR PERSONAL</h6>
                                    <Row className="g-2 align-items-center">
                                        <Col md={7}>
                                            <InputGroup size="sm">
                                                <InputGroup.Text><BsSearch /></InputGroup.Text>
                                                <Form.Control placeholder="Nombre o ID..." value={filtroBusqueda} onChange={(e) => setFiltroBusqueda(e.target.value)} />
                                                <Form.Select value={idEmpleadoAAsignar} onChange={(e) => setIdEmpleadoAAsignar(Number(e.target.value))} className="w-50">
                                                    <option value={0}>-- Seleccione --</option>
                                                    {usuariosFiltrados.map((u) => (
                                                        <option key={u.id} value={u.id}>{u.id} - {u.nombre} | {u.numEmpleado || "0"}</option>
                                                    ))}
                                                </Form.Select>
                                            </InputGroup>
                                        </Col>
                                        <Col md={2} className="text-center">
                                            <Form.Check type="switch" label={<small className="fw-bold">Lectura</small>} checked={esSoloLectura} onChange={(e) => setEsSoloLectura(e.target.checked)} />
                                        </Col>
                                        <Col md={3}>
                                            <Button variant="success" size="sm" className="w-100 fw-bold" onClick={asignarNuevoEmpleado}>VINCULAR</Button>
                                        </Col>
                                    </Row>
                                </div>

                                {loadingDetalle ? <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div> : (
                                    <Table hover responsive className="align-middle border rounded overflow-hidden">
                                        <thead className="table-dark small">
                                            <tr>
                                                <th># Empleado</th>
                                                <th>Nombre</th>
                                                <th className="text-center">Permiso</th>
                                                <th className="text-center">Quitar</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {usuariosAsignados.map((u: any) => {
                                                const idEmp = u.IdEmpleadoUsuario || u.idEmpleadoUsuario;
                                                const lectura = u.SoloLectura === true || u.SoloLectura === 1 || u.soloLectura === 1;
                                                return (
                                                    <tr key={idEmp}>
                                                        <td className="fw-bold">{u.NumEmpleado || u.numEmpleado || "0"}</td>
                                                        <td>
                                                            <div>{u.Nombre || u.nombre}</div>
                                                            <small className="text-muted">{u.Usuario || u.usuario}</small>
                                                        </td>
                                                        <td className="text-center">

                                                            {editingPermisoId === idEmp ? (
                                                                // Modo edición: switch + botones guardar/cancelar
                                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id={`switch-${idEmp}`}
                                                                        label={tempSoloLectura ? "Solo Lectura" : "Escritura"}
                                                                        checked={tempSoloLectura}
                                                                        onChange={(e) => setTempSoloLectura(e.target.checked)}
                                                                    />
                                                                    <Button
                                                                        variant="success"
                                                                        size="sm"
                                                                        className="p-1"
                                                                        onClick={() => actualizarPermiso(idEmp, tempSoloLectura)}
                                                                    >
                                                                        Guardar
                                                                    </Button>
                                                                    <Button
                                                                        variant="secondary"
                                                                        size="sm"
                                                                        className="p-1"
                                                                        onClick={() => {
                                                                            setEditingPermisoId(null);
                                                                            setTempSoloLectura(false);
                                                                        }}
                                                                    >
                                                                        Cancelar
                                                                    </Button>
                                                                </div>
                                                            ) : (
                                                                // Modo visualización: badge + botón editar
                                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                                    {lectura ? (
                                                                        <Badge bg="info" className="text-dark">
                                                                            <BsLockFill className="me-1" /> Lectura
                                                                        </Badge>
                                                                    ) : (
                                                                        <Badge bg="warning" className="text-dark">
                                                                            <BsPencilSquare className="me-1" /> Edición
                                                                        </Badge>
                                                                    )}
                                                                    <Button
                                                                        variant="link"
                                                                        size="sm"
                                                                        className="p-0 text-primary"
                                                                        onClick={() => {
                                                                            setEditingPermisoId(idEmp);
                                                                            setTempSoloLectura(lectura); // Carga el valor actual
                                                                        }}
                                                                    >
                                                                        <BsPencilSquare size={16} />
                                                                    </Button>
                                                                </div>
                                                            )}

                                                        </td>


                                                        <td className="text-center">
                                                            <Button variant="link" className="text-danger p-0" onClick={() => quitarDeNomina(idEmp)}>
                                                                <BsTrash size={18} />
                                                            </Button>
                                                        </td>

                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                )}
                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="text-center p-5 border rounded bg-white shadow-sm h-100 d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '450px' }}>
                            <BsCashStack size={70} className="text-muted mb-4 opacity-25" />
                            <h5 className="text-muted fw-light">Administración Maestro de Nómina</h5>
                            <p className="small text-muted">Seleccione un supervisor para gestionar su personal.</p>
                        </div>
                    )}
                </Col>















            </Row>

            {/* MODAL COPIAR / MOVER */}
            <Modal show={showTransferModal} onHide={() => setShowTransferModal(false)} centered backdrop="static">
                <Modal.Header closeButton className={tipoOperacion === 1 ? "bg-primary text-white" : "bg-danger text-white"}>
                    <Modal.Title className="h6 fw-bold">
                        {tipoOperacion === 1 ? <><BsFiles className="me-2" />COPIAR PERSONAL</> : <><BsArrowLeftRight className="me-2" />MOVER PERSONAL</>}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <p className="text-muted small mb-4">
                        Se procesarán <strong>{usuariosAsignados.length}</strong> empleados del origen: <br />
                        <span className="text-dark fw-bold">{selectedSup?.nombreSupervisor}</span>
                    </p>

                    <Form.Group className="mb-3">
                        <Form.Label className="small fw-bold text-muted text-uppercase">Nominista Destino:</Form.Label>
                        <Form.Select className="border-2" value={idDestinoMasivo} onChange={(e) => setIdDestinoMasivo(Number(e.target.value))}>
                            <option value={0}>-- Seleccione Responsable --</option>
                            {supervisores
                                .filter(s => (s.idSupervisor || s.IdSupervisor) !== (selectedSup?.idSupervisor || selectedSup?.IdSupervisor))
                                .map(s => (
                                    <option key={s.idSupervisor || s.IdSupervisor} value={s.idSupervisor || s.IdSupervisor}>
                                        {s.nombreSupervisor || s.NombreSupervisor}
                                    </option>
                                ))
                            }
                        </Form.Select>
                    </Form.Group>

                    <div className="p-3 bg-light rounded border text-center mt-4">
                        <Form.Label className="small fw-bold text-muted d-block mb-2">PERMISO PARA LOS NUEVOS ACCESOS:</Form.Label>
                        <Form.Check
                            type="switch"
                            id="perm-mas-sw"
                            label={permisoMasivo ? "Solo Lectura (Restringido)" : "Escritura (Permitido)"}
                            checked={permisoMasivo}
                            onChange={(e) => setPermisoMasivo(e.target.checked)}
                            className={permisoMasivo ? "text-info fw-bold" : "text-success fw-bold"}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="outline-secondary" size="sm" onClick={() => setShowTransferModal(false)}>Cancelar</Button>
                    <Button
                        variant={tipoOperacion === 1 ? "primary" : "danger"}
                        size="sm" className="px-4 fw-bold shadow-sm"
                        onClick={ejecutarOperacionMasiva}
                    >
                        Confirmar {tipoOperacion === 1 ? "Copia" : "Movimiento"}
                    </Button>
                </Modal.Footer>
            </Modal>



<Modal
  show={showPeriodosModal}
  onHide={() => setShowPeriodosModal(false)}
  size="xl"
  centered
  scrollable
>
  <Modal.Header closeButton className="bg-dark text-white">
    <Modal.Title className="fs-6 fw-bold">
      Administración de Periodos Cerrados (RH)
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="bg-light p-3">
    {loadingPeriodos ? (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    ) : periodosCerrados.length === 0 ? (
      <div className="text-center py-5 text-muted">
        No hay periodos cerrados en este momento.
      </div>
    ) : (
      <>
        {/* Barra de búsqueda */}
        <Row className="mb-3">
          <Col xs={12} md={6} lg={4}>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Buscar por ID, supervisor, motivo..."
              value={filtroPeriodos}
              onChange={(e) => setFiltroPeriodos(e.target.value)}
            />
          </Col>
        </Row>

        
      </>
    )}

    
  </Modal.Body>

  <Modal.Footer className="bg-white">
    <Button variant="secondary" size="sm" onClick={() => setShowPeriodosModal(false)}>
      Cerrar
    </Button>
  </Modal.Footer>
</Modal>









            <ToastContainer position="top-end" className="p-3">
                <Toast show={showToast} onClose={() => setShowToast(false)} delay={3000} autohide bg="dark">
                    <Toast.Body className="text-white text-center fw-bold">{msgInformativo}</Toast.Body>
                </Toast>
            </ToastContainer>
        </Container>
    );
};

export default GestionMatrizNomina; 